import React from "react";

const BlocksetUppercaseLogo = ({
  height = 76,
  width = 369,
  className,
  fill = "#3D3B3B",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 236 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Blockset"
    >
      <text
        x="0"
        y="38"
        fill={fill}
        fontFamily="Inter, Arial, sans-serif"
        fontSize="42"
        fontWeight="700"
        suppressHydrationWarning
      >
        Blockset
      </text>
    </svg>
  );
};

export default BlocksetUppercaseLogo;
